/**
 * 安全处理来自外部/API/存储的 HTML 与样式，降低 XSS 风险。
 */

import DOMPurify from 'dompurify';

/**
 * 净化 HTML 后再插入 DOM（用于 innerHTML / dangerouslySetInnerHTML）。
 * 来自 API、localStorage 或用户输入的内容在插入前必须经过净化。
 */
export function sanitizeHtml(html: string): string {
  if (typeof html !== 'string') return '';
  return DOMPurify.sanitize(html, { USE_PROFILES: { html: true } });
}

/**
 * 净化用于 <style> 标签的 CSS 内容，防止通过 </style><script> 逃逸造成 XSS。
 * 数据来自 API（如 response.data.settings.styles.styleMap）时使用。
 */
export function sanitizeStyleContent(css: string): string {
  if (typeof css !== 'string') return '';
  return css
    .replace(/<\/style>/gi, '') // 防止闭合 style 标签
    .replace(/<script\b/gi, ''); // 防止注入 script
}
